export default __webpack_public_path__ + "static/media/I0005.9f0f6e2f.png";